import { SVGProps, Ref, forwardRef } from 'react';

import hoc from '@hh.ru/magritte-ui-icon/hoc';

const PlayFilledSize16Component = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M4.33398 3.32642C4.33398 2.67898 4.33398 2.35526 4.46898 2.17681C4.58658 2.02135 4.76633 1.92515 4.96092 1.91353C5.18427 1.9002 5.45363 2.07977 5.99233 2.4389L13.0027 7.11248C13.4478 7.40923 13.6704 7.55761 13.7479 7.74462C13.8158 7.90813 13.8158 8.09188 13.7479 8.25538C13.6704 8.4424 13.4478 8.59078 13.0027 8.88752L5.99233 13.5611C5.45363 13.9202 5.18427 14.0998 4.96092 14.0865C4.76633 14.0749 4.58658 13.9787 4.46898 13.8232C4.33398 13.6447 4.33398 13.321 4.33398 12.6736V3.32642Z"
            fill="var(--magritte-ui-icon-color)"
            stroke="var(--magritte-ui-icon-color)"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
const PlayFilledSize16 = hoc<'PlayFilledSize16'>(forwardRef(PlayFilledSize16Component), 'PlayFilledSize16');
export default PlayFilledSize16;
